const s = {
  name: "MusicBox",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,10c0-2.2,1.8-4,4-4s4,1.8,4,4c0,2.2-1.8,4-4,4S16,12.2,16,10z M20,8c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2
			s2-0.9,2-2C22,8.9,21.1,8,20,8z"/>
		<path class="st0" d="M20,22c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S22.2,22,20,22z M18,26c0-1.1,0.9-2,2-2s2,0.9,2,2
			c0,1.1-0.9,2-2,2S18,27.1,18,26z"/>
		<path class="st0" d="M12,26c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8S12,30.4,12,26z M20,20c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6
			S23.3,20,20,20z"/>
		<path class="st0" d="M14.2,5c0,0.7-0.6,1.2-1.2,1.2S11.8,5.7,11.8,5s0.6-1.2,1.2-1.2S14.2,4.3,14.2,5z"/>
		<path class="st0" d="M8,3c0-1.7,1.3-3,3-3h18c1.7,0,3,1.3,3,3v32c0,1.7-1.3,3-3,3v2h-2v-2H13v2h-2v-2c-1.7,0-3-1.3-3-3V3z M11,2
			c-0.6,0-1,0.4-1,1v32c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1H11z"/>
		<path class="st0" d="M4,25H0v2h4V25z"/>
		<path class="st0" d="M2.7,18.3l3,3l-1.4,1.4l-3-3L2.7,18.3z"/>
		<path class="st0" d="M2.7,33.7l3-3l-1.4-1.4l-3,3L2.7,33.7z"/>
		<path class="st0" d="M40,27h-5v-2h5V27z"/>
		<path class="st0" d="M34.3,30.7l3,3l1.4-1.4l-3-3L34.3,30.7z"/>
		<path class="st0" d="M34.3,21.3l3-3l1.4,1.4l-3,3L34.3,21.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as MusicBox
};
